/** Labels por code number of status of proponent (statusProponente). */
export const PROPONENT_STATUS_LABELS: Record<number, string> = {
  0: 'A iniciar',
  1: 'Aprovado',
  2: 'Recusado',
  3: 'Em análise',
  4: 'Aprovado automaticamente',
  5: 'Aceite com restrição',
  6: 'Pendente proponente',
  7: 'Aguardando aceite',
  8: 'Aprovado por decurso de prazo',
};

/** Legacy mapping (text keys) for the same code number. */
const LEGACY_STATUS_CODE: Record<string, number> = {
  A_INICIAR: 0,
  APROVADO: 1,
  RECUSADO: 2,
  EM_ANALISE: 3,
  APROVADO_AUTOMATICAMENTE: 4,
  ACEITE_COM_RESTRICAO: 5,
  PENDENTE_PROPONENTE: 6,
  AGUARDANDO_ACEITE: 7,
  APROVADO_POR_DECURSO_DE_PRAZO: 8,
};

const STATUS_COLORS: Record<number, string> = {
  0: '#9ca3af',
  1: '#0da31c',
  2: '#f87171',
  3: '#38bdf8',
  4: '#22c55e',
  5: '#fb923c',
  6: '#fbbf24',
  7: '#60a5fa',
  8: '#6b7280',
};

const DEFAULT_STATUS_COLOR = '#9ca3af';

const resolveStatusCode = (status: string | number): number | null => {
  if (typeof status === 'number' && !Number.isNaN(status)) {
    return status in PROPONENT_STATUS_LABELS ? status : null;
  }

  const trimmed = String(status).trim();
  if (trimmed === '') {
    return null;
  }

  if (/^\d+$/.test(trimmed)) {
    const code = Number(trimmed);
    return code in PROPONENT_STATUS_LABELS ? code : null;
  }

  const legacyCode = LEGACY_STATUS_CODE[trimmed.toUpperCase()];
  return legacyCode !== undefined ? legacyCode : null;
};

const AGUARDANDO_ACEITE_STATUS_CODE = 7;

/** Whether the proposal status is "Aguardando aceite". */
export const isAguardandoAceiteStatus = (status: string | number): boolean =>
  resolveStatusCode(status) === AGUARDANDO_ACEITE_STATUS_CODE;

/** Convert code or legacy key of status to the visible label. */
export const mapProponentStatus = (status: string | number): string => {
  const code = resolveStatusCode(status);
  if (code !== null) {
    return PROPONENT_STATUS_LABELS[code];
  }
  return String(status);
};

/** Color associated with the status (code number or legacy key). */
export const getProponentStatusColor = (status: string | number): string => {
  const code = resolveStatusCode(status);
  if (code !== null) {
    return STATUS_COLORS[code] ?? DEFAULT_STATUS_COLOR;
  }
  return DEFAULT_STATUS_COLOR;
};
